import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

/* Clientes com ponto no mapa (coordenadas levantadas no Google Maps). */
export const clientes = [
    { nome: 'Rio Sul Supermercados', local: 'Santo Aleixo, Magé', lat: -22.5620512, lng: -43.0523673 },
    { nome: 'LD Coffee', local: 'Santo Aleixo, Magé', lat: -22.5616888, lng: -43.0518425 },
    { nome: 'Confeitaria Piedade', local: 'Magé', lat: -22.657513, lng: -43.0401843 },
    { nome: 'Rio Sul Supermercados', local: 'Parada Angélica, Duque de Caxias', lat: -22.6201018, lng: -43.2024256 },
    { nome: 'Mariposa', local: 'Aeroporto do Galeão, Rio de Janeiro', lat: -22.8052698, lng: -43.2566277 },
    { nome: 'Tutto Luce', local: 'Centro, Rio de Janeiro', lat: -22.9022478, lng: -43.1873528 },
    { nome: "Boni's Gourmet", local: 'Copacabana, Rio de Janeiro', lat: -22.9690858, lng: -43.184845 },
    { nome: 'Supermercado Maravista', local: 'Itaipu, Niterói', lat: -22.9447542, lng: -43.0350974 },
    { nome: 'Padaria Lady Day', local: 'Barroco, Maricá', lat: -22.9580107, lng: -42.9801153 },
    { nome: 'Padaria Lady Day', local: 'Itaipuaçu, Maricá', lat: -22.9579293, lng: -42.9812707 },
    { nome: 'Mercado Bom Frios Prime', local: 'Centro, Itaboraí', lat: -22.7459221, lng: -42.8624152 },
    { nome: 'Bom Frios Comércio', local: 'Itaboraí', lat: -22.751551, lng: -42.88499 },
    { nome: 'Buffet JM', local: 'Aldeia da Prata, Itaboraí', lat: -22.7675051, lng: -42.9363504 },
    { nome: 'Super Vidal', local: 'Cachoeiras de Macacu', lat: -22.4661573, lng: -42.654856 },
    { nome: 'Real Comary', local: 'Teresópolis', lat: -22.4438211, lng: -42.9787521 },
    { nome: 'Supermercado Armazém Rio', local: 'Araruama', lat: -22.8693016, lng: -42.2762605 },
];

const FABRICA = { nome: 'Fábrica Salato', local: 'Magé', lat: -22.5444909, lng: -43.0440313 };

const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

let leafletPromise = null;
const loadLeaflet = () => {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${LEAFLET_CSS}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = LEAFLET_CSS;
            document.head.appendChild(link);
        }
        const script = document.createElement('script');
        script.src = LEAFLET_JS;
        script.async = true;
        script.onload = () => resolve(window.L);
        script.onerror = () => { leafletPromise = null; reject(new Error('leaflet')); };
        document.body.appendChild(script);
    });
    return leafletPromise;
};

const pinHtml = (fabrica) => `<span class="salatoPin${fabrica ? ' factory' : ''}"><span></span></span>`;

const ClientsMap = () => {
    const mapEl = useRef(null);
    const mapRef = useRef(null);
    const markersRef = useRef([]);
    const [ativo, setAtivo] = useState(null);
    const [erro, setErro] = useState(false);

    useEffect(() => {
        let cancelado = false;
        let observer = null;

        const iniciar = () => loadLeaflet().then((L) => {
            if (cancelado || !mapEl.current || mapRef.current) return;
            const map = L.map(mapEl.current, {
                scrollWheelZoom: false,
                zoomControl: true,
                attributionControl: true,
            });
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>',
            }).addTo(map);

            const icon = (fabrica) => L.divIcon({
                className: 'salatoPinWrap',
                html: pinHtml(fabrica),
                iconSize: fabrica ? [40, 40] : [30, 30],
                iconAnchor: fabrica ? [20, 38] : [15, 28],
                popupAnchor: [0, -26],
            });

            markersRef.current = clientes.map((c, i) => {
                const m = L.marker([c.lat, c.lng], { icon: icon(false), title: c.nome })
                    .addTo(map)
                    .bindPopup(`<strong>${c.nome}</strong><br/>${c.local}`);
                m.on('click', () => setAtivo(i));
                return m;
            });

            L.marker([FABRICA.lat, FABRICA.lng], { icon: icon(true), title: FABRICA.nome, zIndexOffset: 1000 })
                .addTo(map)
                .bindPopup(`<strong>${FABRICA.nome}</strong><br/>Onde tudo é produzido`);

            const bounds = L.latLngBounds([...clientes, FABRICA].map((c) => [c.lat, c.lng]));
            map.fitBounds(bounds, { padding: [28, 28] });
            mapRef.current = map;
        }).catch(() => !cancelado && setErro(true));

        // Só carrega o mapa quando a seção chega perto da tela.
        if ('IntersectionObserver' in window && mapEl.current) {
            observer = new IntersectionObserver((entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    observer.disconnect();
                    iniciar();
                }
            }, { rootMargin: '300px' });
            observer.observe(mapEl.current);
        } else {
            iniciar();
        }

        return () => {
            cancelado = true;
            if (observer) observer.disconnect();
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, []);

    const focar = (i) => {
        setAtivo(i);
        const map = mapRef.current;
        const m = markersRef.current[i];
        if (!map || !m) return;
        map.flyTo(m.getLatLng(), 15, { duration: 0.8 });
        m.openPopup();
    };

    const verTodos = () => {
        setAtivo(null);
        const map = mapRef.current;
        if (!map || !window.L) return;
        map.closePopup();
        map.flyToBounds(window.L.latLngBounds([...clientes, FABRICA].map((c) => [c.lat, c.lng])), { padding: [28, 28], duration: 0.8 });
    };

    return (
        <Area>
            <div className="mapBox">
                <div ref={mapEl} className="mapCanvas" role="region" aria-label="Mapa com os clientes Salato" />
                {erro && <div className="mapFallback">Não foi possível carregar o mapa agora.</div>}
                <div className="mapLegend" aria-hidden="true">
                    <span><i className="dot" /> Clientes</span>
                    <span><i className="dot factory" /> Fábrica Salato</span>
                </div>
            </div>

            <div className="clientList">
                <div className="listHead">
                    <strong>{clientes.length} pontos de venda</strong>
                    <button type="button" onClick={verTodos}>Ver todos</button>
                </div>
                <ul>
                    {clientes.map((c, i) => (
                        <li key={`${c.nome}-${c.local}`}>
                            <button type="button" className={ativo === i ? 'active' : ''} onClick={() => focar(i)}>
                                <span className="pinMini" aria-hidden="true" />
                                <span className="txt">
                                    <strong>{c.nome}</strong>
                                    <small>{c.local}</small>
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </Area>
    );
};

export default ClientsMap;

const Area = styled.div`
    display:grid;
    grid-template-columns:minmax(0, 1.6fr) minmax(0, 1fr);
    gap:8px;
    padding:8px;
    border-radius:28px;
    background:#fff;
    box-shadow:0 0 0 1px var(--salato-line), var(--shadow-md);

    .mapBox{
        position:relative;
        min-height:460px;
        border-radius:22px;
        overflow:hidden;
        background:var(--salato-red-soft);
        isolation:isolate;
    }

    .mapCanvas{
        position:absolute;
        inset:0;
        z-index:0;
    }

    .leaflet-tile-pane{ filter:saturate(.75) contrast(.95); }

    .mapFallback{
        position:absolute;
        inset:0;
        display:grid;
        place-items:center;
        color:var(--salato-muted);
        font-weight:600;
    }

    .mapLegend{
        position:absolute;
        left:12px;
        bottom:12px;
        z-index:500;
        display:flex;
        gap:14px;
        padding:8px 14px;
        border-radius:999px;
        background:rgba(255,255,255,.94);
        box-shadow:var(--shadow-md);
        font-size:12px;
        font-weight:700;
        color:var(--salato-ink);

        span{ display:inline-flex; align-items:center; gap:6px; }

        .dot{
            width:12px;
            height:12px;
            border-radius:50%;
            background:var(--salato-red);
            box-shadow:0 0 0 2px #fff, 0 0 0 3px var(--salato-red);
        }

        .dot.factory{
            background:var(--salato-yellow);
            box-shadow:0 0 0 2px #fff, 0 0 0 3px var(--salato-ink);
        }
    }

    .leaflet-container{ font-family:inherit; }
    .leaflet-popup-content-wrapper{ border-radius:14px; }
    .leaflet-popup-content{
        margin:10px 14px;
        font-size:13px;
        line-height:1.4;
        color:var(--salato-muted);

        strong{ color:var(--salato-ink); font-size:14px; }
    }

    .salatoPinWrap{ background:none; border:0; }

    .salatoPin{
        display:block;
        width:100%;
        height:100%;
        border-radius:50% 50% 50% 0;
        background:var(--salato-red);
        transform:rotate(-45deg);
        box-shadow:0 6px 14px rgba(200, 20, 27, .35);
        border:3px solid #fff;
        transition:transform .2s ease;

        span{
            position:absolute;
            inset:0;
            margin:auto;
            width:34%;
            height:34%;
            border-radius:50%;
            background:#fff;
        }
    }

    .salatoPin.factory{
        background:var(--salato-yellow);
        border-color:var(--salato-ink);
        span{ background:var(--salato-red); }
    }

    .salatoPinWrap:hover .salatoPin{ transform:rotate(-45deg) scale(1.12); }

    .clientList{
        display:flex;
        flex-direction:column;
        min-height:0;
        max-height:460px;
        padding:14px 8px 8px 14px;
    }

    .listHead{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        padding:4px 8px 12px 4px;

        strong{ font-size:16px; color:var(--salato-ink); }

        button{
            border:0;
            padding:7px 14px;
            border-radius:999px;
            background:var(--salato-red-soft);
            color:var(--salato-red);
            font-weight:700;
            font-size:13px;
            cursor:pointer;
            transition:background .2s ease, color .2s ease;

            &:hover{ background:var(--salato-red); color:#fff; }
        }
    }

    ul{
        margin:0;
        padding:0 6px 0 0;
        list-style:none;
        overflow-y:auto;
        display:grid;
        gap:6px;
    }

    li button{
        width:100%;
        display:flex;
        align-items:center;
        gap:12px;
        padding:10px 12px;
        border:0;
        border-radius:14px;
        background:transparent;
        text-align:left;
        cursor:pointer;
        transition:background .2s ease, transform .2s ease;

        &:hover{ background:var(--salato-red-soft); }

        &.active{
            background:var(--salato-red);

            strong, small{ color:#fff; }
            .pinMini{ background:#fff; box-shadow:0 0 0 3px rgba(255,255,255,.35); }
        }
    }

    .pinMini{
        flex:0 0 auto;
        width:10px;
        height:10px;
        border-radius:50%;
        background:var(--salato-red);
        box-shadow:0 0 0 3px var(--salato-red-soft);
    }

    .txt{
        display:flex;
        flex-direction:column;
        min-width:0;

        strong{
            font-size:14px;
            color:var(--salato-ink);
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }

        small{
            font-size:12.5px;
            color:var(--salato-muted);
        }
    }

    @media (max-width:900px){
        grid-template-columns:1fr;

        .mapBox{ min-height:340px; }

        .clientList{
            max-height:300px;
            padding:10px 4px 4px 8px;
        }
    }
`;
